import React from "react";
import { ACTIVITY_OVERDUE } from "../../services/Activities/ActivityStatus";
import { useBackofficeUser } from "../../provider/BackofficeUserProvider";
import { Box, Theme, useTheme } from "@mui/material";
import { Activity } from "../../types/Activity";
import dayjs from "dayjs";

const activityInfoStyles = {
  today: (theme: Theme) => ({
    fontWeight: 700,
    color: theme.palette.primary.main,
  }),
  overdue: {
    color: "#ca0d0d",
  },
  todayAndOverdue: {
    color: "#ca0d0d",
    fontWeight: 700,
  },
  spanContainer: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      whiteSpace: "nowrap",
    },
  }),
};

type ActivityInfoProps = {
  activity: Activity<string>;
};

const ActivityInfo = ({ activity }: ActivityInfoProps) => {
  const { getUserData } = useBackofficeUser();

  const getStyle = (activity: Activity, isToday: boolean) => {
    if (isToday && activity.activityStatus === ACTIVITY_OVERDUE) {
      return activityInfoStyles.todayAndOverdue;
    }
    if (isToday) {
      return activityInfoStyles.today;
    }
    if (activity.activityStatus === ACTIVITY_OVERDUE) {
      return activityInfoStyles.overdue;
    }
  };

  const isToday = dayjs(activity.dueDate).isSame(dayjs(), "day");
  const dateString = isToday ? "Heute" : dayjs(activity.dueDate).format("DD.MM.YYYY");
  const timeString = activity.dueTime !== "allDay" ? "um " + activity.dueTime + " Uhr" : "";

  return (
    <Box sx={activityInfoStyles.spanContainer}>
      <Box component="span" sx={getStyle(activity, isToday)}>
        {dateString} {timeString}
      </Box>{" "}
      |{" "}
      <Box component="span" sx={activity.activityStatus === ACTIVITY_OVERDUE ? activityInfoStyles.overdue : undefined}>
        {activity.assignedUser ? getUserData(activity.assignedUser)!.person.fullname : "Nicht zugewiesen"}
      </Box>
    </Box>
  );
};

export default ActivityInfo;
